export const categories = [
  {
    name: '明星绯闻',
    slug: 'star-scandal',
    icon: 'ri-heart-pulse-line',
    description: '最新明星恋情、绯闻、出轨、离婚等私生活爆料',
  },
  {
    name: '娱乐圈大瓜',
    slug: 'showbiz-news',
    icon: 'ri-fire-line',
    description: '娱乐圈重磅新闻，影视圈、综艺圈、音乐圈最新动态',
  },
  {
    name: '社会热点',
    slug: 'social-hot',
    icon: 'ri-earth-line',
    description: '网络热议的社会事件、争议话题、热门讨论',
  },
  {
    name: '网络热议',
    slug: 'viral-trending',
    icon: 'ri-flashlight-line',
    description: '微博热搜、抖音热门、小红书爆款话题讨论',
  },
  {
    name: '综艺八卦',
    slug: 'variety-show',
    icon: 'ri-tv-line',
    description: '综艺节目幕后爆料、嘉宾八卦、节目争议',
  },
  {
    name: '影视资讯',
    slug: 'film-tv',
    icon: 'ri-movie-line',
    description: '电影电视剧最新消息、票房战报、剧透爆料',
  },
];

export const hotTags = [
  '某女星深夜密会',
  '综艺翻车现场',
  '热播剧大结局',
  '顶流塌方',
  '隐婚生子',
  '片酬风波',
  '选秀内幕',
  '演唱会假唱',
];